import { useEffect, useState } from 'react'

import Api from 'services/api'

import { ProductLiterature } from 'types/ProductLiterature'

const useProductLiterature = (modelNumber) => {
  const [productLiterature, setProductLiterature] = useState<ProductLiterature[]>([])
  const [isProductLiteratureLoaded, setIsProductLiteratureLoaded] = useState(false)
  const [serverError, setServerError] = useState<boolean>(false)

  useEffect(() => {
    setIsProductLiteratureLoaded(false)
    setServerError(false)

    if (modelNumber.length < 4) return

    Api.ProductLiterature.get(modelNumber.substring(0, 12))
      .then((response) => {
        const filteredProductLiterature = response.filter(
          (item) => item.literatureType !== 'Confidential Service Bulletin'
        )

        setProductLiterature(filteredProductLiterature)
      })
      .catch(() => {
        setProductLiterature([])
        setServerError(true)
      })
      .finally(() => { setIsProductLiteratureLoaded(true) })

    setProductLiterature([])
  }, [modelNumber])

  return { productLiterature, isProductLiteratureLoaded, serverError }
}

export default useProductLiterature
